module.exports = __webpack_public_path__ + "assets/img/spoken-gif.2145edcd.gif";